module.exports = __webpack_public_path__ + "img/Silver.053a0c1c.png";